import { Inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router, Params } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { 
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        console.log(" state.url:", state.url );
       

        if (route.url.toString().includes("landing")) {
            return true;
        } else {
            if (localStorage.getItem('jwttoken')==="true") {
                console.log("Inside Else If ",localStorage.getItem('jwttoken'));
                return true;
            } else {
                console.log("Inside Else Else ",localStorage.getItem('jwttoken'));
                this.router.navigate(['/landing']);
                return false;
            }
        }
    }
}
